import { type HTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export interface CodeProps extends HTMLAttributes<HTMLElement> {
	inline?: boolean;
}

const Code = forwardRef<HTMLElement, CodeProps>(
	({ className, inline = true, children, ...props }, ref) => {
		if (inline) {
			return (
				<code
					ref={ref as React.Ref<HTMLElement>}
					className={cn(
						"relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold",
						className,
					)}
					{...props}
				>
					{children}
				</code>
			);
		}

		return (
			<pre
				className={cn("overflow-x-auto rounded-md bg-muted p-4", className)}
				{...(props as HTMLAttributes<HTMLPreElement>)}
			>
				<code ref={ref as React.Ref<HTMLElement>} className="font-mono text-sm">
					{children}
				</code>
			</pre>
		);
	},
);
Code.displayName = "Code";

export default Code;
export { Code };
